import React from "react";
import letters from "../../data/Letters.json";
import contributions from "../../data/Contributions.json";
import "../../styles/Articles.css";
import { useState, useEffect } from "react";

const LettersAndContributions = () => {
  const [lettersData, setLetters] = useState({ letters: [] });
  const [contributionsData, setContributions] = useState({ contributions: [] });
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      setLetters(letters);
      setContributions(contributions);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!lettersData || !contributionsData) return <p>Loading...</p>;

  return (
    <div className="articles-list">
      <h2>Letters to the Editor</h2>
      <div className="articles">
        <ol>
          {lettersData.letters.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ol>
      </div>
      <h2>Contributions</h2>
      <div className="articles">
        <ol>
          {contributionsData.contributions.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default LettersAndContributions;
